import { pluginFactory } from '@/plugins/plugin'
import PLKMap, { TYPE } from './PLKMap.vue'
import services from '@/services'
import i18n from './i18n'

services.translation.init(i18n, { overwrite: false })

const PLKMapPlugin = pluginFactory({
  components: { PLKMap }
})

export { PLKMapPlugin, PLKMap, TYPE }
export default PLKMap
